import { render } from "./FilterItemPrice.vue?vue&type=template&id=89baa958"
import script from "./FilterItemPrice.vue?vue&type=script&lang=js"
export * from "./FilterItemPrice.vue?vue&type=script&lang=js"

import "./FilterItemPrice.vue?vue&type=style&index=0&id=89baa958&lang=scss"

import exportComponent from "D:\\Work\\git\\CatalogOnVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__